import { useEffect, useContext } from 'react';
import { withRouter } from 'react-router-dom';
import Cookies from 'universal-cookie';

import { callBackendAPI, generateSource, cancelToken  } from '../helpers/common';
import { STATUS_SUCCESS } from "./../config/global_constants";
import { UserDetails }  from '../UserDetails';

const SystemLogin = (props) => {
	const userContext = useContext(UserDetails);
	const query 	=	new URLSearchParams(props.location.search);
	const authToken	=	query.get('auth');

	useEffect(() => {
		/** Generate source for cancel token */
		let source = generateSource();

		if (authToken) {
			callBackendAPI([{ model: 'registration', method: 'verifyToken', token: authToken }],source,false).then(response => {
				if(response.success && response.data[0].status === STATUS_SUCCESS){
					let resData = response.data[0];
					let cookieUser = {
						_id				:	resData.result._id,
						full_name		:	resData.result.full_name,
						first_name		:	resData.result.first_name,
						last_name		:	resData.result.last_name,
						email			:	resData.result.email,
						mobile_number	:	resData.result.mobile_number,
						department		:	resData.result.department,
						location		:	resData.result.location,
						slug			:	resData.result.slug,
						role_id			:	resData.result.role_id,
						profile_image	:	(resData.result.image) ? resData.result.image : "",
						token			:	(resData.token) ? resData.token : "",
						image_url		:	(resData.result.file_url) ? resData.result.file_url : "",
						permission_level: 	(resData.result.permission_level) ? resData.result.permission_level : ""
					};

					const cookies = new Cookies();
					cookies.set('user_details', cookieUser, { path: "/" });

					userContext.updateUserState(cookieUser, () => {
						props.history.push('/calendar');
					});
				}else{
					props.history.push('/login');
				}
			}).catch(err => console.log(err));
		}else{
			props.history.push('/login');
		}

		return () => {
			if(source) cancelToken(source);
		}
	}, [authToken, props.history,userContext]);

	return <div className="container mt-5 text-center">
		<img src={`loader.gif`} alt="loading" className='position-absolute top-50 left-50' />
	</div>;
};
export default withRouter(SystemLogin);